export const DEFAULT_STORE_FINDER_ELID = '301703670';
export const WEEK_DAY = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const PROMO_CATEGORIES = ['accessories_promo', 'handsets_promo'];

export const UI_ERROR = {
  TIMEOUT: {
    message: 'Timeout',
  },
} as const;

/*
  Replace associated implementations with Next.js intl config and React-intl
  if the requirement for internationalisation arises
*/
export const DEFAULT_LOCALE = 'en-NZ';
